/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Not_Found_DescriptionInputs */



/**
* | output |
* | --- |
* | "This agent does not exist, or you do not have access to it." |
*
* @param {Agent_Builder_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_not_found_description = /** @type {((inputs?: Agent_Builder_Not_Found_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Not_Found_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Agent existiert nicht oder Sie haben keinen Zugriff darauf.")
	return /** @type {LocalizedString} */ ("This agent does not exist, or you do not have access to it.")
});